import React from "react";
import { Spin, Button } from "antd";
import { getSnapshot } from "mobx-state-tree";
// import axios from "axios";

import pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc =
  require('./../../../node_modules/pdfjs-dist/build/pdf.worker.js');

import ViewerPdf from "./ViewerPdf";

export default class pdfpreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      downloading: true,
      pdf: null,
      error: false
    };
    const { book } = props;
    this.pdfDownload(book);
  }

  pdfDownload = book => {
    const { id, ...data } = getSnapshot(book);

    const hasBridal = 'bridal' in data;

    // URL を条件分岐
    const apiUrl = hasBridal
      ? `${process.env.REACT_APP_BRIDAL_API_ADDR}/book/${id}/`
      : `${process.env.REACT_APP_API_ADDR}/book/${id}/`;

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.arrayBuffer();
      })
      .then(buffer => {
        if (buffer) {
          let loading = pdfjsLib.getDocument({
            data: buffer
          });

          loading.promise
            .then(pdfDocument => {
              this.setState({
                downloading: false,
                pdf: pdfDocument
              });
            })
            .catch(error => {
              console.error("Error: " + error);
              this.setState({
                downloading: false,
                error: true
              });
            });
        } else {
          this.setState({
            downloading: false,
            error: true
          });
        }
      })
      .catch(error => {
        console.error("Error: " + error);
        this.setState({
          downloading: false,
          error: true
        });
      });
    /* axios({
      method: "post",
      url: apiUrl,
      responseType: "arraybuffer",
      data
    })
      .then(response => {
        if (response.data) {
          let loading = pdfjsLib.getDocument({
            data: response.data
          });

          loading.promise
            .then(pdfDocument => {
              this.setState({
                downloading: false,
                pdf: pdfDocument
              });
            })
            .catch(error => {
              console.error("Error: " + error);
              this.setState({
                downloading: false,
                error: true
              });
            });
        } else {
          this.setState({
            downloading: false,
            error: true
          });
        }
      })
      .catch(error => {
        console.error("Error: " + error);
        this.setState({
          downloading: false,
          error: true
        });
      }); */
  };

  render() {
    if (this.state.downloading) {
      return <Spin />;
    }

    if (this.state.error || !this.state.pdf) {
      return "Error";
    }

    return (
      <div className="preview">
        <ViewerPdf doc={this.state.pdf} />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/pdfPreview/pdfpreview.js